module.exports = __webpack_public_path__ + "cf536fa85f67ed2c96f9abb037a48fd0.MP3";